// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".overflow-y-auto[data-v-63188809]::-webkit-scrollbar{width:6px}.overflow-y-auto[data-v-63188809]::-webkit-scrollbar-track{background:#f1f1f1;border-radius:3px}.overflow-y-auto[data-v-63188809]::-webkit-scrollbar-thumb{background:#c1c1c1;border-radius:3px}.overflow-y-auto[data-v-63188809]::-webkit-scrollbar-thumb:hover{background:#a8a8a8}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
